import ResourceManager from "../../components/ResourceManager"
import { useCalendarEventMutations } from "../hooks/use-calendar-event-mutations"
import { useI18n } from "../../hooks/use-i18n"
import { useOptions } from "../../options/hooks/use-options"
import { StringMap } from "../../types/common"
import { CalendarEventViewModel } from "../api/calendar-event"

const EventWorkspacesWidget = ({ calendarEvent }: EventWorkspacesWidgetProps) => {
  const translations = useTranslations(defaultTranslations)
  const { updateWorkspaces } = useCalendarEventMutations()
  const { workspaceOptions } = useOptions(calendarEvent.organisation?.id || "")

  const onAddWorkspaces = (ids: string[]) => {
    const workspaces = [
      ...calendarEvent.workspaces,
      ...workspaceOptions.filter((w) => ids.includes(w.id)).map((w) => ({ id: w.id, name: w.name })),
    ]
    updateWorkspaces(calendarEvent.id, workspaces)
  }

  const onRemoveWorkspace = (workspaceId: string) => {
    const workspaces = calendarEvent.workspaces.filter((w) => w.id !== workspaceId)

    updateWorkspaces(calendarEvent.id, workspaces)
  }

  const sortedWorkspaceOptions = workspaceOptions
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  const sortedWorkspaces = calendarEvent.workspaces
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={sortedWorkspaceOptions}
      resources={sortedWorkspaces}
      canAddResource={calendarEvent.canUpdate}
      canRemoveResource={calendarEvent.canUpdate}
      onAddResources={onAddWorkspaces}
      onRemoveResource={onRemoveWorkspace}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection
    />
  )
}

const useTranslations = (defaults = defaultTranslations): EventWorkspacesWidgetTranslations => {
  const { translations: t } = useI18n("calendarEvent")
  const translations = (t?.workspacesWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Workspaces",
  emptyOptionsMessage: "No workspaces in this organisation",
  emptyResourcesMessage: "This event is not connected to any workspace",
  updateErrorMessage: "Failed to update workspaces",
}

type EventWorkspacesWidgetTranslations = typeof defaultTranslations
type EventWorkspacesWidgetProps = { calendarEvent: CalendarEventViewModel }
export default EventWorkspacesWidget
